'use strict';

/**
 * Normalise a file path by ensuring the path starts with the protocol.
 *
 * If the path already starts with the protocol, no change will be made.
 *
 * @param path
 * @returns {string|*}
 */
module.exports = {
    prependFileSchemeToPath: function prependFileSchemeToPath(path) {
        var prefix = 'file://';
        if (!path) {
            return path;
        } else if (path.startsWith(prefix + '/')) {
            return path;
        } else if (path.startsWith('/')) {
            return '' + prefix + path;
        } else {
            return prefix + '/' + path;
        }
    }
};